import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];

    if (
        props.keys !== undefined
        // &&
        // props.venueListUtilization !== undefined
    ) {
        for (const key of Object.keys(props.keys[0])) {
            let keyNetwork = [];

            for (const keyName of Object.keys(props.keys[0][key])) {
                if (keyName === "ssid") {
                    keyNetwork[key] = props.keys[0][key][keyName];
                }
                if (keyName !== "ssid" && keyName !== "DisplayOrder" && keyName !== "AuthenticationMechanism") {
                    // let keytag = props.keys[0][key][keyName]['KeyTag']
                    // let keypsk = props.keys[0][key][keyName]['psk']
                    // let keynetwork = props.keys[0][key][keyName]['network']
                    // let keyselectednetworkindex = props.keys[0][key][keyName]['selectedNetworkIndex']
                    // let iswpa2 = props.keys[0][key][keyName]['wpa2enterprise_auth']
                    // let devices = props.keys[0][key][keyName]['Devices']
                    // console.log(keytag)
                    // console.log(props.keys[0][key][keyName]['KeyTag'])
                    //   i = i + 1;
                    userAttributes.push({
                        id: i,
                        keyselectednetworkindex: i,
                        keyid: keyName,
                        status: props.keys[0][key][keyName]["currentState"],
                        profile: props.keys[0][key][keyName]["KeyTag"],
                        network: keyNetwork[key],
                        activated:
                            props.keys[0][key][keyName][
                                "dateAddedUTC.ISO8601"
                            ] !== undefined
                                ? Intl.DateTimeFormat("en-US", {
                                      month: "numeric",
                                      day: "numeric",
                                      year: "numeric",
                                  }).format(
                                      new Date(
                                          props.keys[0][key][keyName][
                                              "dateAddedUTC.ISO8601"
                                          ]
                                      )
                                  )
                                : "",
                        psk: props.keys[0][key][keyName]["psk"],
                        iswpa2: props.keys[0][key][keyName][
                            "wpa2enterprise_auth"
                        ],
                        devices: props.keys[0][key][keyName]["Devices"],
                        venueUnitPolicies:
                            props.keys[0][key][keyName]["VenueUnitPolicies"],
                        //  expiring: "",
                        // clickEvent: ()=>props.toggleManageKey(true, keyid, keytag, keypsk, keynetwork, keyselectednetworkindex, iswpa2, devices)
                    });
                }
            }

            i = i + 1;

            //  if (
            //   props.venueListUtilization[props.venueList[key]["VenueID"]] !==
            //   undefined
            // ) {
            // if (props.venueUnitPolicyInfo !== undefined) {
            //   userAttributes.push({
            //     id: key,
            //     profileName: props.profileName,
            //     networkName: props.networkName,
            //     venueName: props.venueUnitPolicyInfo[key]["VenueName"],
            //     unitName: props.venueUnitPolicyInfo[key]["UnitID"],
            //     buildingName: props.venueUnitPolicyInfo[key]["UnitBuilding"],
            //     floorName: props.venueUnitPolicyInfo[key]["UnitFloor"],
            //     psk: props.psk
            //   });

            // }
        }
    }
    columns = [
        {
            headerName: "Status",
            field: "status",
            // minWidth: 120,
            flex: 0.2,
            renderCell: (params) =>
                params.row.status === "Active" ? (
                    <div className="active-circle"></div>
                ) : (
                    <div className="inactive-circle"></div>
                ),
        },
        {
            headerName: "Profile",
            field: "profile",
            // minWidth: 120,
            flex: 0.2,
        },
        {
            headerName: "Network",
            field: "network",
            flex: 0.2,
            minWidth: 200,
        },
        {
            headerName: "Activated",
            field: "activated",
            flex: 0.2,
            minWidth: 200,
        },
    ];
    rows = userAttributes;
    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 60 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
                disableRowSelectionOnClick={true}
                onRowClick={(id) =>
                    props.toggleManageKey(
                        true,
                        id.row["keyid"],
                        id.row["profile"],
                        id.row["psk"],
                        id.row["network"],
                        id.row["keyselectednetworkindex"],
                        id.row["iswpa2"],
                        id.row["devices"],
                        id.row["venueUnitPolicies"]
                    )
                    // console.log(id.row)
                }
            />
        </div>
    );
}
